import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function QuestionOverlay({ question, counter, currentIndex, totalQuestions, onNext, onPrev, onAnswered }) {
  const [userAns, setUserAns] = useState('');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setUserAns('');
    setSubmitted(false);
  }, [question]);

  const onSubmit = () => {
    setSubmitted(true);
    onAnswered();
  };

  const handleNext = () => {
    setUserAns('');
    setSubmitted(false);
    onNext();
  };

  return (
    <div className="overlay">
      <motion.div 
        className="card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="header">
          <span role="img" aria-label="book">📚</span> Question {currentIndex + 1} of {totalQuestions} | <span role="img" aria-label="check">✅</span> Answered: {counter}
        </div>
        <div className="body">
          <motion.div 
            className="question"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.3 }}
          >
            {question.question}
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.3 }}
          >
            <textarea
              value={userAns}
              onChange={e => setUserAns(e.target.value)}
              placeholder="Type your answer..."
            />
            <motion.button 
              onClick={onSubmit} 
              disabled={submitted}
              whileHover={{ scale: submitted ? 1 : 1.03 }}
              whileTap={{ scale: submitted ? 1 : 0.97 }}
            >
              {submitted ? 'Submitted' : 'Submit'}
            </motion.button>
          </motion.div>
          {submitted && (
            <motion.div 
              className="answer-section"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              transition={{ duration: 0.4 }}
            >
              <p><strong>Your answer:</strong> {userAns || '(No answer provided)'}</p>
              <p><strong>Correct answer:</strong> {question.answer}</p>
            </motion.div>
          )}
        </div>
        <div className="footer">
          <motion.button 
            onClick={onPrev}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <span role="img" aria-label="back" style={{ marginRight: '5px' }}></span> Back
          </motion.button>
          <motion.button 
            onClick={handleNext}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            Next <span role="img" aria-label="next" style={{ marginLeft: '5px' }}></span>
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}
